import { gql } from '@apollo/client';

const GET_ALL_LITE_PURCHASE_INTENT = gql`
  query paginateLitePurchaseIntent(
    $first: Int!
    $after: LitePurchaseIntentCursorInput!
  ) {
    paginateLitePurchaseIntent(first: $first, after: $after) {
      edges {
        node {
          purchaseIntentId
          customerRut
          purchaseIntent {
            concessionaireId
            price
          }
          createdAt
          car {
            model
            vehicleType
            cit
          }
          operationalCosts {
            totalOperationalCost
          }
          insurance {
            insuranceProposal {
              proposalProductId
              proposalInternalWebPageUrl
            }
            insuranceInput {
              useType
            }
            insuranceId
          }
          customer {
            rut
          }
        }
        cursor {
          purchaseIntentId
        }
      }
      pageInfo {
        startCursor {
          purchaseIntentId
          createdAt
        }
        endCursor {
          purchaseIntentId
          createdAt
        }
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

const GET_LITE_PURCHASE_INTENT = gql`
  query unitedLitePurchaseIntent {
    unitedLitePurchaseIntent {
      purchaseIntentId
      quotationId
      obligatoryInsurance
      tag
      customerRut
      purchaseIntent {
        concessionaireId
        price
      }
      createdAt
      car {
        carId
        createdAt
        brand
        model
        year
        vehicleType
        price
        cit
      }
      insurance {
        insuranceInput {
          carPlate
          paymentType
          useType
        }
        insuranceId
      }
      customer {
        createdAt
        name
        firstSurname
        rut
        phone
        email
        commune
      }
      operationalCosts {
        procedures {
          name
          price
          selected
        }
        totalOperationalCost
      }
    }
  }
`;

const CREATE_LITE_PURCHASE_INTENT = gql`
  mutation createLitePurchaseIntent(
    $createLitePurchaseIntentInput: CreateLitePurchaseIntentInput!
  ) {
    createLitePurchaseIntent(
      createLitePurchaseIntentInput: $createLitePurchaseIntentInput
    ) {
      customerRut
      obligatoryInsurance
      tag
      purchaseIntentId
      purchaseIntent {
        concessionaireId
        price
      }
      createdAt
      car {
        carId
        createdAt
        brand
        model
        year
        price
        cit
      }
      customer {
        createdAt
        name
        firstSurname
        rut
        phone
        email
        commune
      }
      operationalCosts {
        procedures {
          name
          price
          selected
        }
        totalOperationalCost
      }
      insurance {
        insuranceProposal {
          proposalProductId
          proposalInternalWebPageUrl
        }
      }
    }
  }
`;

const LIST_LITE_PURCHASE_INTENT_TO_CSV = gql`
  query listLitePurchaseIntentToCsv($dateRange: [String!]!) {
    listLitePurchaseIntentToCsv(dateRange: $dateRange)
  }
`;

const LIST_INSURANCE_PROPOSAL_TO_CSV = gql`
  query listInsuranceProposalToCsv($dateRange: [String!]!) {
    listInsuranceProposalToCsv(dateRange: $dateRange)
  }
`;

const LIST_PURCHASE_TO_CSV = gql`
  query listPurchaseToCsv($dateRange: [String!]!) {
    listPurchaseToCsv(dateRange: $dateRange)
  }
`;

const SEARCH_LITE_PURCHASE_INTENT_TO_CSV = gql`
  query searchLitePurchaseIntent($searchInput: SearchInput!) {
    searchLitePurchaseIntent(searchInput: $searchInput) {
      purchaseIntentId
      createdAt
      car {
        model
      }
      insurance {
        insuranceProposal {
          proposalProductId
          proposalInternalWebPageUrl
        }
      }
      customer {
        name
        firstSurname
        rut
      }
    }
  }
`;

const purchaseIntentOperations = {
  LIST_PURCHASE_TO_CSV,
  LIST_INSURANCE_PROPOSAL_TO_CSV,
  CREATE_LITE_PURCHASE_INTENT,
  SEARCH_LITE_PURCHASE_INTENT_TO_CSV,
  GET_ALL_LITE_PURCHASE_INTENT,
  GET_LITE_PURCHASE_INTENT,
  LIST_LITE_PURCHASE_INTENT_TO_CSV,
};

export default purchaseIntentOperations;
